import tw from 'tailwind-styled-components'

export const Breadcrumbs = tw.div`
px-8 
text-[12px]
text-darkGray/80
`
export const TitleHeader = tw.div`
text-lg
font-semibold
text-blueTheme
`

export const FirstTextBreadcrumbs = tw.span`
mr-1
cursor-pointer
`

export const SecondTextBreadcrumbs = tw.span`
font-semibold 
ml-1
`

export const AboveProgressBar = tw.div`
px-8 
flex 
flex-row 
justify-between 
items-center 
`
export const AboveProgressBarText = tw.span`
font-semibold
text-lg
text-blueTheme
`

export const ActionsButtonsWrapper = tw.div`
flex 
justify-end
flex-wrap
gap-4
`

export const actionsBack = `
p-4 
border-blueTheme 
text-blueTheme
`
export const actionsNext = `
p-4 
bg-blueTheme
text-white
text-sm
items-center
hover:brightness-90
transition-all
`

export const ButtonAction = tw.button`
text-sm
border-[1px]
rounded-lg
h-[38px]
inline-flex
items-center
hover:brightness-95
transition-all
active:scale-[.97]
`
export const ArchiveButton = tw.button`
px-4
border 
rounded-lg 
py-2
border-amberAlt
text-amberAlt
font-medium
text-sm
flex
items-center
gap-2
hover:brightness-90
transition-all
`

export const ForwardButton = tw.button`
px-4
border 
rounded-lg 
py-2
bg-blueTheme
text-white
text-sm
flex
items-center
gap-2
hover:brightness-90
transition-all
`
